import { MarriageOfficialUpateTypes } from '@/enums/MarriageOfficialsUpdateTypes';
import { SortingType } from '@/enums/sortingtypes';
import { LicenseActionsMetaModel, RequestActionsIdsModel } from '@/models/licenseModels/licenseListModel';
import { StringObject } from '@/models/object';
import { RequestActionsMetaModel } from '@/models/requestsModels/requestsListModel';
import i18n from '@/plugins/i18n';

export const RequestActionsIds: RequestActionsIdsModel = {
  view: 1,
  edit: 2,
  delete: 3,
  viewNotes: 4,
  viewRejectionReasons: 5,
  editCancelRequest: 6,
  viewUpdateName: 7,
  viewIncompleteReasons: 8,
  viewClosingReasons: 9,
};

export const RequestTypesIds: StringObject = {
  newRequest: 1,
  reNewRequest: 2,
  reRegisterRequest: 3,
  cancelRequest: 4,
  reissueRequest: 5,
  updateNameRequest: 6,
  updateLicenseRequest: 7,
};

export const RequestTypesNames = {
  [RequestTypesIds.newRequest]: i18n.t('newLicenseRequest') as string,
  [RequestTypesIds.reNewRequest]: i18n.t('renewLicenseRequest') as string,
  [RequestTypesIds.reRegisterRequest]: i18n.t('reregisterLicenseRequest') as string,
  [RequestTypesIds.reissueRequest]: i18n.t('reissueLicenseRequest') as string,
  [RequestTypesIds.cancelRequest]: i18n.t('cancelLicenseRequest') as string,
  [RequestTypesIds.updateLicenseRequest]: i18n.t('updatePersonalInfo') as string,
  [RequestTypesIds.updateNameRequest]: i18n.t('updateNameRequest') as string,
};

export const RequestsTypesLinks = {
  new: '/new-request',
  renew: '/renew-request',
  reregister: '/reregister-request',
  reissueLink: '/reissue-license',
  cancel: '/cancellation-request',
  cancelViewOrEdit: '/cancellation-request/request',
  viewRequest: '/view-request',
  viewLicense: '/license-details',
  updateLicense: '/update-license-request',
  updateName: '/update-name-request',
};

export const RequestsTypesUrls = {
  [RequestTypesIds.newRequest]: RequestsTypesLinks.new,
  [RequestTypesIds.reNewRequest]: RequestsTypesLinks.renew,
  [RequestTypesIds.reRegisterRequest]: RequestsTypesLinks.reregister,
  [RequestTypesIds.reissueRequest]: RequestsTypesLinks.reissueLink,
  [RequestTypesIds.cancelRequest]: RequestsTypesLinks.cancel,
  [RequestTypesIds.updateLicenseRequest]: RequestsTypesLinks.updateLicense,
  [RequestTypesIds.updateNameRequest]: RequestsTypesLinks.updateName,
};

export const RequestActionsMeta:RequestActionsMetaModel = {
  [RequestActionsIds.view]: {
    icon: 'n-icon-eye',
    label: i18n.t('marriageOfficialRequestsList.view') as string,
    url: RequestsTypesLinks.viewRequest,
    onClick: null,
  },
  [RequestActionsIds.viewIncompleteReasons]: {
    icon: 'n-icon-document-text',
    label: i18n.t('marriageOfficialRequestsList.uncompleteResons') as string,
    url: RequestsTypesLinks.viewRequest,
    onClick: null,
  },
  [RequestActionsIds.edit]: {
    icon: 'n-icon-edit',
    label: i18n.t('marriageOfficialRequestsList.edit') as string,
    url: '',
    onClick: null,
  },

  [RequestActionsIds.delete]: {
    icon: 'n-icon-note-remove',
    label: i18n.t('marriageOfficialRequestsList.delete') as string,
    url: '',
    onClick: null,
  },

  [RequestActionsIds.viewNotes]: {
    icon: 'n-icon-document-text',
    label: i18n.t('marriageOfficialRequestsList.viewNotes') as string,
    url: '',
    onClick: null,
  },

  [RequestActionsIds.viewRejectionReasons]: {
    icon: 'n-icon-document-text',
    label: i18n.t('marriageOfficialRequestsList.viewRejectionReasons') as string,
    url: RequestsTypesLinks.viewRequest,
    onClick: null,
  },

  [RequestActionsIds.editCancelRequest]: {
    icon: 'n-icon-edit',
    label: i18n.t('marriageOfficialRequestsList.editCancelRequest') as string,
    url: RequestsTypesLinks.cancelViewOrEdit,
    onClick: null,
  },

  [RequestActionsIds.viewUpdateName]: {
    icon: 'n-icon-document-text',
    label: i18n.t('marriageOfficialRequestsList.view') as string,
    url: RequestsTypesLinks.updateName,
    onClick: null,
  },

  [RequestActionsIds.viewClosingReasons]: {
    icon: 'n-icon-document-text',
    label: i18n.t('marriageOfficialRequestsList.viewClosingReasons') as string,
    url: RequestsTypesLinks.viewRequest,
    onClick: null,
  },
};

export const LicenseActionsIds = {
  view: 0,
  renew: 1,
  reRegister: 2,
  reIssue: 3,
  cancel: 4,
  updateName: 5,
  updateData: 6,
  update: 56, // not in system lookup but computed from 5 , 6
  download: 57, // not in system lookup but computed from 5 , 6
};

export const LicenseActionsMeta: LicenseActionsMetaModel = {
  [LicenseActionsIds.view]: {
    icon: 'n-icon-eye',
    label: i18n.t('marriageOfficialRequestsList.viewLicense') as string,
    url: RequestsTypesLinks.viewLicense,
    onClick: null,
  },
  [LicenseActionsIds.download]: {
    icon: 'n-icon-receive-square',
    label: i18n.t('licenseAndDetails.downloadLicense') as string,
    url: '',
    onClick: null,
  },
  [LicenseActionsIds.renew]: {
    icon: 'n-icon-refresh-circle',
    label: i18n.t('marriageOfficialRequestsList.renewLicense') as string,
    url: RequestsTypesLinks.renew,
    onClick: null,
  },
  [LicenseActionsIds.reRegister]: {
    icon: 'n-icon-edit',
    label: i18n.t('marriageOfficialRequestsList.reRegisterLicense') as string,
    url: RequestsTypesLinks.reregister,
    onClick: null,
  },
  [LicenseActionsIds.reIssue]: {
    icon: 'n-icon-refresh-left-square',
    label: i18n.t('marriageOfficialRequestsList.reIssueLicense') as string,
    url: RequestsTypesLinks.reissueLink,
    onClick: null,
  },
  [LicenseActionsIds.cancel]: {
    icon: 'n-icon-note-remove',
    label: i18n.t('marriageOfficialRequestsList.cancelLicnese') as string,
    url: RequestsTypesLinks.cancel,
    onClick: null,
  },
  [LicenseActionsIds.updateName]: {
    icon: 'n-icon-user-edit',
    label: i18n.t('marriageOfficialRequestsList.updateMarriageOfficalData') as string,
    url: `/update/${MarriageOfficialUpateTypes.name}`,
    onClick: null,
  },
  [LicenseActionsIds.updateData]: {
    icon: 'n-icon-user-edit',
    label: i18n.t('marriageOfficialRequestsList.updateMarriageOfficalData') as string,
    url: `/update/${MarriageOfficialUpateTypes.data}`,
    onClick: null,
  },
  [LicenseActionsIds.update]: {
    icon: 'n-icon-user-edit',
    label: i18n.t('marriageOfficialRequestsList.updateMarriageOfficalData') as string,
    url: '/update',
    onClick: null,
  },
};

export const RequestStatuses:{ [x: string]: number;} = {
  new: 1,
  approved: 100,
  rejected: 110,
  cancel: 150,
  returnToComplete: 120,
  processing: 20,
  underReview: 40,
  reviewPapers: 30,
  underProcess: 50,
  underProcess1: 60,
  underProcess2: 130,
  underProcess3: 160,
  underProcess4: 170,
  underProcess5: 180,
  underProcess6: 190,
  completedFromClient: 200,
  approveFromjudicialLicense: 80,
  incomplete: 90,
  changeFromClient: 140,
  closed: 210,
};
export const RequestStatusesLocalized = [
  {
    id: RequestStatuses.new,
    name: i18n.t('marriageOfficialRequestsList.requestTypeNew'),
  },
  {
    id: RequestStatuses.approved,
    name: i18n.t('marriageOfficialRequestsList.requestTypeCompleted'),
  },
  {
    id: RequestStatuses.returnToComplete,
    name: i18n.t('marriageOfficialRequestsList.requestTypeReturenToComplete'),
  },
  {
    id: RequestStatuses.cancel,
    name: i18n.t('marriageOfficialRequestsList.requestTypeCanceled'),
  },
  {
    id: RequestStatuses.rejected,
    name: i18n.t('marriageOfficialRequestsList.requestTypeRejected'),
  },
  {
    id: RequestStatuses.underReview,
    name: i18n.t('marriageOfficialRequestsList.requestTypeUnderReview'),
  },
  {
    id: RequestStatuses.incomplete,
    name: i18n.t('marriageOfficialRequestsList.requestTypeInComplete'),
  },
];

export const RequestStatusChipColor:{ [x: number]: string;} = {
  [RequestStatuses.new]: 'default ',
  [RequestStatuses.approved]: 'success',
  [RequestStatuses.rejected]: 'danger',
  [RequestStatuses.cancel]: 'danger',
  [RequestStatuses.returnToComplete]: 'info',
  [RequestStatuses.processing]: 'warning',
  [RequestStatuses.underReview]: 'warning',
  [RequestStatuses.reviewPapers]: 'warning',
  [RequestStatuses.underProcess]: 'warning',
  [RequestStatuses.underProcess1]: 'warning',
  [RequestStatuses.underProcess2]: 'warning',
  [RequestStatuses.underProcess3]: 'warning',
  [RequestStatuses.underProcess4]: 'warning',
  [RequestStatuses.underProcess5]: 'warning',
  [RequestStatuses.underProcess6]: 'warning',
  [RequestStatuses.completedFromClient]: 'info',
  [RequestStatuses.approveFromjudicialLicense]: 'success',
  [RequestStatuses.incomplete]: 'danger',
  [RequestStatuses.changeFromClient]: 'info',

};

export const licenseStatus = {
  active: '1',
  inActive: '2',
};

export const LocalizedRequestStatus = [
  {
    id: licenseStatus.active,
    name: i18n.t('marriageOfficialList.active'),
  },
  {
    id: licenseStatus.inActive,
    name: i18n.t('marriageOfficialList.inActive'),
  },
];

export const RequestStatusesMeta = {
  [RequestStatuses.new]: {
    color: 'warning',
    icon: 'alert-circle-outline',
    text: i18n.t('requestStatusesMessages.new'),
    status: 'success',
  },
  [RequestStatuses.approved]: {
    color: 'success',
    icon: 'check-circle',
    text: i18n.t('requestStatusesMessages.approved'),
    status: 'success',
  },

  [RequestStatuses.rejected]: {
    color: 'danger',
    icon: 'alert-circle-outline',
    text: i18n.t('requestStatusesMessages.rejected'),
    status: 'error',
  },

  [RequestStatuses.cancel]: {
    color: 'danger',
    icon: 'alert-circle-outline',
    text: i18n.t('requestStatusesMessages.canceled'),
    status: 'error',
  },

  [RequestStatuses.returnToComplete]: {
    color: 'info',
    icon: 'alert-circle-outline',
    text: i18n.t('requestStatusesMessages.returnedToComplete'),
    status: 'error',
  },
  [RequestStatuses.underReview]: {
    color: 'warning',
    icon: 'information-outline',
    text: i18n.t('requestStatusesMessages.underReview'),
    status: 'pending',
  },
  [RequestStatuses.processing]: {
    color: 'warning',
    icon: 'information-outline',
    text: i18n.t('requestStatusesMessages.processing'),
    status: 'pending',
  },
  [RequestStatuses.reviewPapers]: {
    color: 'info',
    icon: 'information-outline',
    text: i18n.t('requestStatusesMessages.reviewPapers'),
    status: 'pending',
  },
  [RequestStatuses.underProcess]: {
    color: 'warning',
    icon: 'information-outline',
    text: i18n.t('requestStatusesMessages.underProcess'),
    status: 'pending',
  },
  [RequestStatuses.underProcess1]: {
    color: 'warning',
    icon: 'information-outline',
    text: i18n.t('requestStatusesMessages.underProcess'),
    status: 'pending',
  },
  [RequestStatuses.underProcess2]: {
    color: 'warning',
    icon: 'information-outline',
    text: i18n.t('requestStatusesMessages.underProcess'),
    status: 'pending',
  },
  [RequestStatuses.underProcess3]: {
    color: 'warning',
    icon: 'information-outline',
    text: i18n.t('requestStatusesMessages.underProcess'),
    status: 'pending',
  },
  [RequestStatuses.underProcess4]: {
    color: 'warning',
    icon: 'information-outline',
    text: i18n.t('requestStatusesMessages.underProcess'),
    status: 'pending',
  },
  [RequestStatuses.underProcess5]: {
    color: 'warning',
    icon: 'information-outline',
    text: i18n.t('requestStatusesMessages.underProcess'),
  },
  [RequestStatuses.underProcess6]: {
    color: 'warning',
    icon: 'information-outline',
    text: i18n.t('requestStatusesMessages.underProcess'),
  },
  [RequestStatuses.completedFromClient]: {
    color: 'warning',
    icon: 'information-outline',
    text: i18n.t('requestStatusesMessages.changeFromClient'),
  },
  [RequestStatuses.changeFromClient]: {
    color: 'warning',
    icon: 'information-outline',
    text: i18n.t('requestStatusesMessages.changeFromClient'),
    status: 'error',
  },
  [RequestStatuses.incomplete]: {
    color: 'info',
    icon: 'alert-circle-outline',
    text: i18n.t('requestStatusesMessages.incomplete'),
  },
  [RequestStatuses.approveFromjudicialLicense]: {
    color: 'info',
    text: i18n.t('requestStatusesMessages.approveFromjudicialLicense'),
    status: 'success',
  },
  [RequestStatuses.closed]: {
    color: 'info',
    icon: 'alert-circle-outline',
    text: i18n.t('requestStatusesMessages.closed'),
    status: 'error',
  },
  fallback: {
    color: 'warning',
    text: i18n.t('requestStatusesMessages.fallback'),
    status: 'error',
  },
};

export const AttachmentTypeIds = {
  personalPicture: 1,
  academicQualificationCopy: 4,
  certificateEquivalencyCopy: 5,
  licenseSuspension: 13,
  rejectionReason: 14,
  medicalExamination: 12,
  writtenTest: 8,
  updateNameNotification: 15,
};

export const AttachmentNamesByIds = {
  [AttachmentTypeIds.personalPicture]: i18n.t('personalPicture'),
  [AttachmentTypeIds.academicQualificationCopy]: i18n.t('academicQualificationCopy'),
  [AttachmentTypeIds.certificateEquivalencyCopy]: i18n.t('certificateEquivalencyCopy'),
  [AttachmentTypeIds.licenseSuspension]: i18n.t('licenseSuspension'),
  [AttachmentTypeIds.rejectionReason]: i18n.t('rejectionReason'),
  [AttachmentTypeIds.medicalExamination]: i18n.t('medicalExamination'),
  [AttachmentTypeIds.writtenTest]: i18n.t('writtenTest'),
  [AttachmentTypeIds.updateNameNotification]: i18n.t('updateNameNotification'),
};

export const OTPCounterTypes = {
  minutes: 'm',
  seconds: 's',
};

export const HandledServerErrorsStatuses = [500];
export const LicenseNumberQueryName = 'licenseNumber';
export const IsWaselAddressKey = 'isWaselAddress';

export const RequestType = [
  {
    id: RequestTypesIds.newRequest,
    name: i18n.t('marriageOfficialRequestsList.newRequest'),
  },
  {
    id: RequestTypesIds.reNewRequest,
    name: i18n.t('marriageOfficialRequestsList.renewLicenseRequest'),
  },
  {
    id: RequestTypesIds.reissueRequest,
    name: i18n.t('marriageOfficialRequestsList.reissuelLicnese'),
  },
  {
    id: RequestTypesIds.updateNameRequest,
    name: i18n.t('updateNameRequest'),
  },
  {
    id: RequestTypesIds.updateLicenseRequest,
    name: i18n.t('marriageOfficialRequestsList.updateMarriageOfficalData'),
  },
  {
    id: RequestTypesIds.reRegisterRequest,
    name: i18n.t('marriageOfficialRequestsList.reRegisterMarriageOfficalLicense'),
  },

  {
    id: RequestTypesIds.cancelRequest,
    name: i18n.t('marriageOfficialRequestsList.cancelLicneseRequest'),
  },
];

export const SortingTypes = [
  {
    value: SortingType.newest,
    label: i18n.t('newest'),
  },
  {
    value: SortingType.oldest,
    label: i18n.t('oldest'),
  },
];
